import { RemoveOfferResult } from 'hooks/loyalty'
import { useState } from 'react'
import OfferCard from 'components/OfferCard'
import { AppliedDiscount, getOfferName } from 'utils/loyalty'
import { buildTranslate } from 'locales'
import { Discount } from '@squareup/sq-addons-web-sdk'

const t = buildTranslate('customer.offerCard')

type Props = {
  discount: Discount
  onRemoveOffer: (offer: AppliedDiscount) => Promise<RemoveOfferResult>
}

const RedeemedOfferCard = ({ discount, onRemoveOffer }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  async function removeOffer() {
    if (discount?.uid) {
      setIsLoading(true)
      setError(null)
      const result = await onRemoveOffer({
        offerId: discount.metadata?.offerId,
        redemptionId: discount.metadata?.redemptionId,
        discountId: discount.uid,
      })
      setIsLoading(false)
      if (result.isErr()) {
        setError(result.error)
      }
    }
  }

  function formatCurrency(cents: number) {
    return `$${(cents / 100).toFixed(2)}`
  }

  return (
    <OfferCard
      isRedeemed
      kind="redeemed-offer"
      offerId={discount.metadata?.offerId}
    >
      <OfferCard.Label>{getOfferName(discount)}</OfferCard.Label>
      <OfferCard.Subtext>
        {formatCurrency(discount.amountMoney?.amount)}
      </OfferCard.Subtext>
      {!!error && <OfferCard.ErrorText>{error.message}</OfferCard.ErrorText>}
      <OfferCard.Button isLoading={isLoading} onClick={removeOffer}>
        {t('remove')}
      </OfferCard.Button>
    </OfferCard>
  )
}

export default RedeemedOfferCard
